import React, { useLayoutEffect, useRef, useState } from "react";

import moment from "moment-timezone";

import { valueStrings } from "constants/constantStrings.js";
import { DATE_FORMAT } from "constants/globalConstants.js";
import { DashboardWidgetsMenuItems } from "constants/widgetsMenu.config";

import DupontIconButton from "components/DupontIconButton";
import { DupontTooltip } from "components/DupontTooltip/index.js";
import PopoverMenu from "components/PopoverMenu";

import MenuIcon from "assets/SvgIcon/cardviewMenu/menu_Default";

import { isEllipsisActive } from "../../../utils/utils";

import TagPopover from "./../Tags/TagPopover.jsx";

const WidgetHeader = props => {
  const { title, description, units, onWidgetAction, WidgetID, tagData, customClass } = props;

  const [menuTargetEl, setMenuTargetEl] = React.useState(null);
  const menuHandler = event => setMenuTargetEl(event.currentTarget);
  const [tagNameEllipse, setTagNameEllipse] = useState(false);
  const [tagDescriptionEllipse, setTagDescriptionEllipse] = useState(false);
  const tagNameRef = useRef(null);
  const tagDescriptionRef = useRef(null);

  const unitsText = units ? `(${units})` : "";

  let { duration } = props;

  const onMenuClose = data => {
    setMenuTargetEl(null);
    if (data) {
      onWidgetAction(data.id, WidgetID);
    }
  };

  const getTimeDuration = () => {
    let tempDate;
    const currentDate = moment().valueOf();
    const endTime = Math.floor(currentDate / 1000);
    const today = moment.unix(endTime).format(DATE_FORMAT);
    const dur = duration.split(" ")[0];
    tempDate = moment().subtract(dur, "months").toString();
    const startTime = Math.floor(new Date(tempDate).getTime() / 1000);
    const past = moment.unix(startTime).format(DATE_FORMAT);
    if (dur > 1) {
      duration += "s";
    }
    return `${duration} (${past} - ${today})`;
  };

  useLayoutEffect(() => {
    setTagNameEllipse(isEllipsisActive(tagNameRef));
    const multilineTruncated = tagDescriptionRef.current?.offsetHeight < tagDescriptionRef.current?.scrollHeight;
    setTagDescriptionEllipse(multilineTruncated);
  }, [tagNameRef?.current?.scrollWidth]);

  return (
    <>
      <div className="flex-between-center height24">
        <DupontTooltip title={title} placement="bottom-start" type={tagNameEllipse ? "primary" : "none"}>
          <span className="overflow bodyMainHeadingText" ref={tagNameRef}>
            {title} {unitsText} {duration && <span className="duration__label">{getTimeDuration()}</span>}
          </span>
        </DupontTooltip>
        <div className="autoLeftMargin flex-between">
          {tagData && <TagPopover tagData={tagData} />}
          <DupontIconButton tooltip={valueStrings.menu} onClick={menuHandler} active={menuTargetEl ? true : false}>
            <MenuIcon />
          </DupontIconButton>
          <PopoverMenu menuItems={DashboardWidgetsMenuItems} parentElem={menuTargetEl} onMenuClose={onMenuClose} />
        </div>
      </div>
      <div>
        {description && (
          <DupontTooltip title={description} placement="bottom-start" maxwidth={215} type={tagDescriptionEllipse ? "primary" : "none"}>
            <span className={`${customClass} descriptionText padding-bottom-2`} ref={tagDescriptionRef}>
              {description}
            </span>
          </DupontTooltip>
        )}
      </div>
    </>
  );
};

WidgetHeader.defaultProps = {
  numberOfLines: 1
};

export default WidgetHeader;
